import type { Maybe } from '@adornis/base/utilTypes.js';
import { Float, Int } from '@adornis/baseql/baseqlTypes.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { KPF } from '../../master-data-management/kpf/entities/KPF.js';

@Entity()
export class KPIKPFReport extends MongoEntity {
  static override _class = 'KPIKPFReport';
  static override _collectionName = 'kpi-kpf-reports';

  @Field(() => Int)
  year: Maybe<number>;

  @Field(() => Int)
  month: Maybe<number>;

  @DataLoadedField(() => KPF, ({ kpfId }) => kpfId)
  kpf: Maybe<KPF>;

  @Field(() => String)
  kpfId: Maybe<string>;

  @Field(() => Int)
  activeUS: Maybe<number>;

  @Field(() => Int)
  activeOS: Maybe<number>;

  @Field(() => Float)
  attendancePercent: Maybe<number>;

  @Field(() => Int)
  newRegistrations: Maybe<number>;
}
